import ApiService from "../../core/services/api-service";
export default {
    namespaced: true,
    state: () => ({
        token: null,
    }),
    mutations: {
        // MUTATIONS - Any synchronous global state actions must be called with mutations.
        // I.E we might update Signer Information using a mutation but perform an ajax request which updates the token in an action
        signInSuccessful(state, payload) {
            state.token = payload.token;
        },
        signOut(state) {
            state.token = null;
        },
    },
    actions: {
        // ACTIONS - Any global state altering method must be called using an action
        // I.E we might update Signer Information using a mutation but perform an ajax request which updates the token in an action
        async authenticate({commit}, payload) {

        },
        signOut({commit}) {

        }
    },
    getters: {
        token: (state) => {
            return state.token;
        },
    }
}
